import '@rmwc/circular-progress/circular-progress.css';
import { CircularProgress as C } from '@rmwc/circular-progress';

export const CircularProgress = C;
export default CircularProgress;
